import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Parallax, Navigation } from "swiper/modules";
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoPython, BiLogoHtml5, BiLogoCss3, BiLogoReact, BiLogoWordpress, BiLogoPhp, BiLogoVuejs, BiLogoFlutter } from "react-icons/bi";

const WebentwicklungEntwickeltMit = () => {
    const { t } = useTranslations();

    return (
        <section className="partner-area ptb-100 webdev-technologies-section">
            {/* Hintergrund-Dekoration */}
            <div className="bg-decoration bg-decoration-1"></div>
            <div className="bg-decoration bg-decoration-2"></div>

            <div className="container">
                <div className="row align-items-center">
                    <div className="partner-title webdev-title">
                        <h2 className="webdev-title-text">
                            {t('webDevelopment_technologies_title')}
                            <span className="webdev-title-underline"></span>
                        </h2>
                        <p className="webdev-title-description">
                            {t('webDevelopment_technologies_description')}
                        </p>
                    </div>
                    <div className="col-md-12">
                        <Swiper
                            className="webdevswiper"
                            speed={800}
                            parallax={true}
                            pagination={{
                                clickable: true,
                                dynamicBullets: true,
                            }}
                            navigation={{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            }}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            modules={[Parallax, Pagination, Navigation, Autoplay]}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 5
                                },
                                768: {
                                    slidesPerView: 1,
                                    spaceBetween: 30
                                },
                                1024: {
                                    slidesPerView: 1,
                                    spaceBetween: 40
                                }
                            }}
                        >
                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_html5_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoHtml5 className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_html5_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_css_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoCss3 className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_css_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_react_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoReact className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_react_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_wordpress_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoWordpress className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_wordpress_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_php_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoPhp className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_php_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_vue_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoVuejs className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_vue_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_python_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoPython className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_python_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="webdev-slide-card">
                                    <div className="about-content webdev-content">
                                        <span className="sub-title webdev-subtitle" data-swiper-parallax="-200">
                                            {t('webDevelopment_technologies_flutter_title')}
                                        </span>
                                        <div className="webdev-icon-container">
                                            <BiLogoFlutter className="webdev-icon" />
                                        </div>
                                    </div>
                                    <div className="text webdev-text" data-swiper-parallax="-100">
                                        <p>
                                            {t('webDevelopment_technologies_flutter_description')}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WebentwicklungEntwickeltMit;
